import { inject, Injectable } from '@angular/core';
import { Subscription } from 'rxjs';

import { HubConnection, SignalRService } from '@core/signalr/signalr.service';
import { environment } from '@env';
import { NotificationViewModel } from 'src/.graphql/types';

import { HUB_LISTENER_NAME, HUB_NAME } from '../constants/notification-constants';
import { NotificationStoreService } from '../store/services/notification-store.service';
import {
    connectionReconnected$,
    notificationsLoaded,
    notificationStream$,
    unviewedNotificationsCount,
} from '../store/services/notification.store';

@Injectable({ providedIn: 'root' })
export class NotificationsSignalRService {
    private readonly signalRService = inject(SignalRService);
    private readonly notificationStoreService = inject(NotificationStoreService);

    private hub: HubConnection | null = null;
    private listenerSubscription: Subscription | null = null;

    public async connect(): Promise<void> {
        this.disconnect();

        const url = `${environment.notificationsUrl}/${HUB_NAME}`;

        this.hub = await this.signalRService.createHub(HUB_NAME, url);

        this.listenerSubscription = this.signalRService
            .createHubListener<{ notifications: NotificationViewModel[] }>(this.hub, HUB_LISTENER_NAME)
            .subscribe(data => {
                notificationStream$.next(data.notifications);

                if (notificationsLoaded()) {
                    this.notificationStoreService.processNotifications(data.notifications);
                } else {
                    unviewedNotificationsCount.update(count => count + data.notifications.length);
                }
            });

        this.hub.hub.onreconnected(() => connectionReconnected$.next());
    }

    public disconnect(): void {
        if (this.hub == null) {
            return;
        }

        this.listenerSubscription?.unsubscribe();
        this.listenerSubscription = null;
        this.signalRService.removeHubListener(this.hub, HUB_LISTENER_NAME);
        this.hub.disconnect();
        this.hub = null;
    }
}
